// @ts-nocheck
import _ from 'lodash';

const DEFAULT_PAGE_CONFIG = {
  customerIdentity: {
    required: false,
    fetch: false,
    hook: () => ({ redirectUrl: undefined }),
  },
  user: {
    authorize: () => ({ success: true }),
    fetch: true,
    kinds: ['customer', 'worker', 'expert'],
    required: true,
  },
  timeout: {
    value: -1,
  },
};

export const DEFAULT_CORP_PAGE_CONFIG = {
  user: {
    kinds: ['corp'],
    required: true,
  },
};

const DEFAULT_OUTLIER_PAGE_CONFIG = {
  user: {
    kinds: ['expert'],
    required: true,
  },
};

export const getPageConfig = (ctx, Component, router) => {
  const isCorpPage = router.route.startsWith('/corp/');
  const isExpertPage = router.route.startsWith('/expert');
  const cfgWithoutDefaults = Component.getPageConfig ? Component.getPageConfig(ctx) : {};

  // apply defaults to each property of the cfg
  const cfgWithDefaults = _.mapValues(DEFAULT_PAGE_CONFIG, (v, k) =>
    _.defaults(
      {},
      cfgWithoutDefaults[k],
      isCorpPage ? DEFAULT_CORP_PAGE_CONFIG[k] : isExpertPage ? DEFAULT_OUTLIER_PAGE_CONFIG[k] : {},
      v,
    ),
  );

  return cfgWithDefaults;
};
